import { STATUS_TYPE } from '../../../enum';

export interface GetDealerSettings {
  id: string;
}

export interface DealerSettings {
  id: string;
  financeAppLink?: string;
  financeAppMessage?: string;
  googleLink?: string;
  financeSmsSendActive?: boolean;
  dealershipWebsite?: string;
  dealershipEmail?: string;
  dealershipPhone?: string;
  salesPhoneNumber?: string;
  servicePhoneNumber?: string;
  partsPhoneNumber?: string;
  financePhoneNumber?: string;
  dealershipAddress?: string;
  dealershipHours?: string;
  dealershipSpecialOffers?: string;
  paperSizeId?: string;
  paperSize?: {
    id: string;
    name: string;
    width: number;
    height: number;
    description?: string;
  };
  promotionalOfferId?: string;
  promotionalOffer?: {
    id: string;
    name: string;
    code: string;
    description?: string;
  };
  advisorGreenMax?: number;
  advisorYellowMax?: number;
  advisorSlaMinutes?: number;
}

interface InitialState {
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
  settings: DealerSettings | null;
  status: STATUS_TYPE;
}

export const initialState: InitialState = {
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
  settings: null,
  status: 'idle',
};
